<template>
    <div>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="330px">
                <v-card>
                    <v-card-title>
                        <span
                            class="headline">
                            {{ $vuetify.lang.t('$vuetify.logoutModal.logout') }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                {{ $vuetify.lang.t('$vuetify.logoutModal.msgConfirm') }}
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            outlined
                            @click="dialog = false">
                            {{ $vuetify.lang.t('$vuetify.logoutModal.cancel') }}
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="confirm()">
                            {{ $vuetify.lang.t('$vuetify.logoutModal.confirm') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'LogoutModal',

    data () {
        return {
            dialog: false
        }
    },

    methods: {
        openModal () {
            this.dialog = true
        },

        confirm () {
            localStorage.setItem('jwt', null)
            localStorage.setItem('username', null)

            this.$store.dispatch('clearBranch')

            this.$router.push({ name: 'Login' }, () => {})
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
